var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--main main"},[_c('portal-header'),_c('main-header',{staticClass:"main__header"}),_c('router-view',{staticClass:"main__content",attrs:{"name":"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }